import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as componentTypes from "../../../constants/componentTypes";
import * as navigationActions from "../../../actions/navigationActions";
import * as rccActions from "../../../actions/rccActions";
import * as colorHelper from "../../../helpers/colorHelper";
import * as validationHelper from "../../../helpers/validationHelper";
import * as modelHelper from "../../../helpers/modelHelper";
import Rgb from "../../../models/utils/Rgb";

import Button from "../generic/Button";
import CancelButton from "../generic/CancelButton";
import Input from "../generic/Input";
import Modal from "../generic/Modal";

import imgConfirm from "../../../resources/img/svgicons/confirm.svg";

class SpectroManualInputModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            labL: 0,
            labA: 0,
            labB: 0,
            xyzX: 0,
            xyzY: 0,
            xyzZ: 0,
            rgbR: 0,
            rgbG: 0,
            rgbB: 0
        };
    }

    componentDidMount() {
        const spectroResult = this.props.spectro && this.props.spectro.result ? this.props.spectro.result : null;
        if (spectroResult) {
            this.setState({
                labL: spectroResult.lab[0],
                labA: spectroResult.lab[1],
                labB: spectroResult.lab[2],
                xyzX: spectroResult.xyz[0],
                xyzY: spectroResult.xyz[1],
                xyzZ: spectroResult.xyz[2],
                rgbR: spectroResult.rgb[0],
                rgbG: spectroResult.rgb[1],
                rgbB: spectroResult.rgb[2]
            });
        }
    }

    isValueValid = (value, name) => {
        if (name === "labL") {
            return validationHelper.isLabLValueValid(value);
        }
        if (name === "labA") {
            return validationHelper.isLabAValueValid(value);
        }
        if (name === "labB") {
            return validationHelper.isLabBValueValid(value);
        }
        if (name === "xyzX") {
            return validationHelper.isXyzXValueValid(value);
        }
        if (name === "xyzY") {
            return validationHelper.isXyzYValueValid(value);
        }
        if (name === "xyzZ") {
            return validationHelper.isXyzZValueValid(value);
        }
        return false;
    };

    getRgbHex = () => {
        if (this.state.rgbR !== "" && this.state.rgbG !== "" && this.state.rgbB !== "") {
            const rgb = new Rgb(Number(this.state.rgbR), Number(this.state.rgbG), Number(this.state.rgbB));
            return rgb.hex.toUpperCase();
        }

        return "";
    };

    handleValueChange = (event, name) => {
        const value = Number(event.target.value);
        const valueValid = this.isValueValid(value, name);
        let newState = {
            ...this.state,
            [name]: valueValid ? value : this.state[name]
        };

        if (valueValid) {
            if (name.includes("lab")) {
                const xyz = colorHelper.labToXyz({labL: newState.labL, labA: newState.labA, labB: newState.labB});
                if (xyz) {
                    const rgb = colorHelper.xyzToRgb({xyzX: xyz.xyzX, xyzY: xyz.xyzY, xyzZ: xyz.xyzZ});
                    newState = {
                        ...newState,
                        xyzX: xyz.xyzX,
                        xyzY: xyz.xyzY,
                        xyzZ: xyz.xyzZ,
                        rgbR: rgb.rgbR,
                        rgbG: rgb.rgbG,
                        rgbB: rgb.rgbB
                    };
                }
            }
            if (name.includes("xyz")) {
                const lab = colorHelper.xyzToLab({xyzX: newState.xyzX, xyzY: newState.xyzY, xyzZ: newState.xyzZ});
                if (lab) {
                    const rgb = colorHelper.xyzToRgb({xyzX: newState.xyzX, xyzY: newState.xyzY, xyzZ: newState.xyzZ});
                    newState = {
                        ...newState,
                        labL: lab.labL,
                        labA: lab.labA,
                        labB: lab.labB,
                        rgbR: rgb.rgbR,
                        rgbG: rgb.rgbG,
                        rgbB: rgb.rgbB
                    };
                }
            }
        }

        this.setState(newState);
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleConfirmClick = () => {
        this.props.dispatchSaveManualInputResultAction(
            [Number(this.state.labL), Number(this.state.labA), Number(this.state.labB)],
            this.getRgbHex(),
            [this.state.rgbR, this.state.rgbG, this.state.rgbB],
            [this.state.xyzX, this.state.xyzY, this.state.xyzZ]
        );
        this.props.dispatchCloseModalAction();
    };

    handleInputFocus = (event) => {
        event.target.select();
    };

    getLabResult = () => {
        let lab = [];

        lab.push(
            <div key="2" className="col-3 flex flex-align-center-vertical">
                <div className="color-primary margin-right-5 col-1">L: </div>
                <Input
                    type="number"
                    className="primary-input col-6 min-width-65"
                    value={this.state.labL}
                    onChange={(e) => this.handleValueChange(e, "labL")}
                    onFocus={this.handleInputFocus}
                />
            </div>
        );

        lab.push(
            <div key="3" className="col-3 flex flex-align-center-vertical">
                <div className="color-primary margin-right-5 col-1">a:</div>
                <Input
                    type="number"
                    className="primary-input col-6 min-width-65"
                    value={this.state.labA}
                    onChange={(e) => this.handleValueChange(e, "labA")}
                    onFocus={this.handleInputFocus}
                />
            </div>
        );

        lab.push(
            <div key="4" className="col-3 flex flex-align-center-vertical">
                <div className="color-primary margin-right-5 col-1">b:</div>
                <Input
                    type="number"
                    className="primary-input col-6 min-width-65"
                    value={this.state.labB}
                    onChange={(e) => this.handleValueChange(e, "labB")}
                    onFocus={this.handleInputFocus}
                />
            </div>
        );

        return lab;
    };

    getRgbResult = () => {
        let rgb = [];

        rgb.push(
            <div key="6" className="col-3 flex flex-align-center-vertical">
                <div className="color-primary margin-right-5 col-1">R:</div>
                <Input
                    type="number"
                    className="primary-input col-6 min-width-65"
                    value={this.state.rgbR}
                    readOnly={true}
                    disabled
                />
            </div>
        );

        rgb.push(
            <div key="7" className="col-3 flex flex-align-center-vertical">
                <div className="color-primary margin-right-5 col-1">G:</div>
                <Input
                    type="number"
                    className="primary-input col-6 min-width-65"
                    value={this.state.rgbG}
                    readOnly={true}
                    disabled
                />
            </div>
        );

        rgb.push(
            <div key="8" className="col-3 flex flex-align-center-vertical">
                <div className="color-primary margin-right-5 col-1">B:</div>
                <Input
                    type="number"
                    className="primary-input col-6 min-width-65"
                    value={this.state.rgbB}
                    readOnly={true}
                    disabled
                />
            </div>
        );

        return rgb;
    };

    getXyzResult = () => {
        let xyz = [];

        xyz.push(
            <div key="9" className="col-3 flex flex-align-center-vertical">
                <div className="color-primary margin-right-5 col-1">X:</div>
                <Input
                    type="number"
                    className="primary-input col-6 min-width-65"
                    value={this.state.xyzX}
                    onChange={(e) => this.handleValueChange(e, "xyzX")}
                    onFocus={this.handleInputFocus}
                />
            </div>
        );

        xyz.push(
            <div key="10" className="col-3 flex flex-align-center-vertical">
                <div className="color-primary margin-right-5 col-1">Y:</div>
                <Input
                    type="number"
                    className="primary-input col-6 min-width-65"
                    value={this.state.xyzY}
                    onChange={(e) => this.handleValueChange(e, "xyzY")}
                    onFocus={this.handleInputFocus}
                />
            </div>
        );

        xyz.push(
            <div key="11" className="col-3 flex flex-align-center-vertical">
                <div className="color-primary margin-right-5 col-1">Z:</div>
                <Input
                    type="number"
                    className="primary-input col-6 min-width-65"
                    value={this.state.xyzZ}
                    onChange={(e) => this.handleValueChange(e, "xyzZ")}
                    onFocus={this.handleInputFocus}
                />
            </div>
        );

        return xyz;
    };

    getColorPreview = () => {
        const rgbHex = this.getRgbHex();

        if (rgbHex === "") {
            return <div className="col-12 height-100px" />;
        }

        return <div className="col-12 height-100px" style={{backgroundColor: rgbHex}} />;
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12 flex flex-align-center-vertical">
                    <div className="margin-right-10 col-3">
                        <div className="color-primary">Lab D65/10: </div>
                    </div>
                    {this.getLabResult()}
                </div>
                <div className="col-12 flex flex-align-center-vertical">
                    <div className="margin-right-10 col-3">
                        <div className="color-primary">XYZ D65/10: </div>
                    </div>
                    {this.getXyzResult()}
                </div>
                <div className="col-12 flex flex-align-center-vertical">
                    <div className="margin-right-10 col-3">
                        <div className="color-primary">RGB (sRGB):</div>
                    </div>
                    {this.getRgbResult()}
                </div>
                <div className="col-12 flex flex-align-center-vertical padding-bottom-10">
                    <div className="margin-right-10 col-3">
                        <div className="color-primary">RGB (hex):</div>
                    </div>
                    <div className="margin-right-3 col-3">
                        <div className="disabled">{this.getRgbHex()}</div>
                    </div>
                </div>
                <div className="col-12 padding-bottom-5 padding-top-10">{this.getColorPreview()}</div>
            </React.Fragment>,
            "flex-row-gap-10px flex-wrap slim-scroll col-12"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="flex">
                    <Button
                        className="margin-right-5"
                        onClick={this.handleConfirmClick}
                        label={<Translate value="general.confirm" />}
                        svgBefore={imgConfirm}
                    />
                    <CancelButton onClick={this.handleCloseModalClick} />
                </div>
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="spectroTab.measurementResult" />)}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{minWidth: "40%"}}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        spectro: store.spectro.spectro
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.SPECTRO_MANUAL_INPUT_MODAL));
        },
        dispatchSaveManualInputResultAction: (lab, rgbHex, rgb, xyz) => {
            dispatch(rccActions.saveSpectroManualInput(lab, rgbHex, rgb, xyz));
        }
    };
};

export default SpectroManualInputModal = connect(mapStoreToProps, mapDispatchToProps)(SpectroManualInputModal);
